import { render } from "./newPart.vue?vue&type=template&id=59f99cbf"
import script from "./newPart.vue?vue&type=script&lang=js"
export * from "./newPart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__